import RxCheckBox from "./RxCheckBox";

export default RxCheckBox;
